import InputSearch from 'src/components/organisms/InputSearch';
import styled from 'styled-components/macro';

export const StyledInputSearch = styled(InputSearch)`
  width: 360px;
`;
